<template>
  <form class="column is-12" @submit.prevent="onSubmit">
    <div class="columns is-multiline">
      <div class="column is-12">
        <h3 class="title is-5">Cantidad de compra</h3>
      </div>
      <div class="column is-7">
        <div class="field">
          <p>SOMOS COMERCIALIZADORES MAYORISTAS DE TEXTIL.
            Mínimo de venta: 1 rollo de tela, que dependiendo la referencia oscila entre los 50 y 100 metros.</p>
        </div>
        <div class="field">
          <label for="quantity" class="label">Cantidad de compra (En rollos)</label>
          <input type="number" class="input" id="quantity" v-model="quantity" placeholder="Cantidad en rollos">
        </div>
        <div class="field">
          <input type="checkbox" class="checkbox" id="performanceTable" v-model="performanceTable">
          <label for="performanceTable">Conozco la <a
              href="https://stilotex-website.s3.amazonaws.com/docs/Rendimiento+por+rollo-%2B%2B%2B%2B.xlsx" target="_blank">tabla</a> de rendimientos</label>
        </div>
      </div>
      <div class="column is-6">
        <button class="button is-black" :disabled="!quantity || !performanceTable">Siguiente</button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: "TotalQuantity",
  data() {
    return {
      quantity: '',
      performanceTable: false
    }
  },
  methods: {
    onSubmit() {
      this.$emit('done', {
        totalFabric: {
          key: 'totalQty',
          quantity: this.quantity,
          performanceTable: this.performanceTable
        }
      });
    },
  }
}
</script>

<style scoped>
a {
  font-weight: bold;
  color: #ffffff;
}
</style>
